"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_73_9_1 = void 0;
/**
 * Migrate to 73.9.1
 *
 * convert both properties to be explicitly of type boolean!
 * before they could be undefined..
 *
 */
const migration_73_9_1 = (json) => {
    json.IsIgnoreSafetyDistance = json.IsIgnoreSafetyDistance === true;
    json.IsStackingOfLeitungenAllowed = json.IsStackingOfLeitungenAllowed === true;
    return json;
};
exports.migration_73_9_1 = migration_73_9_1;
//# sourceMappingURL=migration_73_9_1.js.map